import orgBillingData, { billingCount } from '../../pages/supBilling/supBillingFun/fetchOrgBilling';
import orgPayoutsData, { payoutCount } from '../../pages/supBilling/supPayoutsFun/fetchOrgPayouts';

const commonBaseAPIServiceConfig = {
    fetchBillingCount: ({ selectedOrg, setTotalCount, selectedStatus, selectedApproval, setLoading, serviceType }) => {
        return billingCount(selectedOrg, setTotalCount, selectedStatus, selectedApproval, setLoading, serviceType);
    },
    fetchBillingData: async ({
        limit,
        offSet,
        selectedOrg,
        selectedStatus,
        selectedApproval,
        setBillingData,
        setLoading,
        serviceType
    }) => {
        return await orgBillingData(
            limit,
            offSet,
            selectedOrg,
            selectedStatus,
            selectedApproval,
            setBillingData,
            setLoading,
            serviceType
        );
    },
    fetchPayoutData: async ({ selectedOrg, limit, offSet, setPayoutData, setLoading, serviceType }) => {
        return await orgPayoutsData(selectedOrg, limit, offSet, setPayoutData, setLoading, serviceType);
    },
    fetchPayoutCount: ({ selectedOrg, setTotalCount, setLoading, serviceType }) => {
        return payoutCount(selectedOrg, setTotalCount, setLoading, serviceType);
    }
};

export const supBillingsServiceConfig = {
    trip: commonBaseAPIServiceConfig,
    gu: commonBaseAPIServiceConfig,
    act: commonBaseAPIServiceConfig,
    // camp / stay: one billing row per booking (backend shapes it like the others)
    camp: commonBaseAPIServiceConfig
};
